/**
 * Labstep
 *
 * @module core/Text/Placeholder
 * @desc TextPlaceholder (Add and Placeholder)
 */

import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import type { ITextPlaceholderProps } from './types';

export const TextPlaceholder: RFC<ITextPlaceholderProps> = ({
  children,
  onClick,
}) => (
  <span
    className={classNames(styles.textPlaceholder, {
      [styles.clickable]: !!onClick,
    })}
    onClick={onClick}
  >
    {children}
  </span>
);
